import { CheckCircle2, CircleAlert, Wrench, XCircle, type LucideIcon } from "lucide-react"
import type { TingkatStatus } from "@/modules/status/domain/types"

export const KELAS_TITIK: Record<TingkatStatus, string> = {
  normal: "bg-success",
  lambat: "bg-warning",
  gangguan: "bg-destructive",
  pemeliharaan: "bg-info",
}

export const KELAS_TEKS: Record<TingkatStatus, string> = {
  normal: "text-success",
  lambat: "text-warning",
  gangguan: "text-destructive",
  pemeliharaan: "text-info",
}

export const KELAS_PANEL: Record<TingkatStatus, string> = {
  normal: "border-success/30 bg-success/[0.06]",
  lambat: "border-warning/30 bg-warning/[0.06]",
  gangguan: "border-destructive/30 bg-destructive/[0.06]",
  pemeliharaan: "border-info/30 bg-info/[0.06]",
}

export const IKON_TINGKAT: Record<TingkatStatus, LucideIcon> = {
  normal: CheckCircle2,
  lambat: CircleAlert,
  gangguan: XCircle,
  pemeliharaan: Wrench,
}
